// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3kkLl","modal":"Modal_modal__2RH0v","slide-down":"Modal_slide-down__1FzXK"};